import React from 'react'
import { Tooltip } from '@mui/material'
import { DarkMode as DarkModeIcon, LightMode as LightModeIcon, OpenInNew } from '@mui/icons-material'
import { PrivatePage } from '../component/PagePrivate'
import { ViewToggle } from '../component/ViewToggle'
import { NotificationV2 } from '../container/common/NotificationV2'
import { ProfileV2 } from '../container/common/ProfileV2'
import { useAdminTheme } from '../hook/useAdminTheme'
import paypro from '../asset/paypro.jpg'
import l from './SubscribersPageV2.module.css'
import s from '../component/payment-v2/PaymentV2.module.css'

/*
 * Payment aggregators in the v2 admin design — the classic page
 * (PaymentPage.tsx) redrawn: the same provider card, PayPro, with its status
 * and the link to the provider. The classic card's description was
 * placeholder text; it says what PayPro does here instead.
 */

type Provider = { logo: string; name: string; status: 'active' | 'inactive'; text: string; link: string }

const PROVIDERS: Provider[] = [
  {
    logo: paypro,
    name: 'PayPro',
    status: 'active',
    text: 'Takes the payments for packages and subscriptions — the checkout users are sent to when they buy.',
    link: 'https://payproglobal.com/',
  },
]

export function PaymentPageV2() {
  const { theme, toggleTheme } = useAdminTheme()

  const header = (
    <div className={`${l.theme} ${l.header}`} data-theme={theme}>
      <div className={l.crumb}><small>Settings</small><b>Payment aggregators</b></div>
      <div className={l.spacer} />
      <ViewToggle dark={theme === 'dark'} />
      <Tooltip title={theme === 'dark' ? 'Light theme' : 'Dark theme'}>
        <button className={l.iconBtn} onClick={toggleTheme} aria-label="Toggle theme">
          {theme === 'dark' ? <LightModeIcon sx={{ fontSize: 17 }} /> : <DarkModeIcon sx={{ fontSize: 17 }} />}
        </button>
      </Tooltip>
      <NotificationV2 />
      <ProfileV2 />
    </div>
  )

  return (
    <PrivatePage header={header}>
      <div className={`${l.theme} ${l.page}`} data-theme={theme}>
        <div className={s.grid}>
          {PROVIDERS.map((p) => (
            <div key={p.name} className={s.card}>
              <div className={s.top}>
                <img className={s.logo} src={p.logo} alt="" />
                <span className={`${s.status} ${p.status === 'active' ? s.statusOn : ''}`}>
                  <i />{p.status === 'active' ? 'Active' : 'Inactive'}
                </span>
              </div>
              <b className={s.name}>{p.name}</b>
              <p className={s.text}>{p.text}</p>
              <div className={s.foot}>
                <a className={s.link} href={p.link} target="_blank" rel="noopener noreferrer">More info<OpenInNew sx={{ fontSize: 15 }} /></a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </PrivatePage>
  )
}
